import React from 'react';
import Icon from 'antd/lib/icon';
import Layout from 'antd/lib/layout';
import 'antd/lib/layout/style/index.css';
var selfStyles = require('./styles.scss');
var PageError = function (props) { return (React.createElement(Layout.Content, { className: selfStyles.center },
    React.createElement("div", { className: selfStyles.errorWrapper },
        React.createElement(Icon, { type: 'frown-o', className: selfStyles.errorIcon }),
        React.createElement("h1", { className: selfStyles.errorTitle }, props.errorTitle),
        React.createElement("h4", null, props.errorMessage)))); };
export default PageError;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageError/index.tsx
// module id = 747
// module chunks = 0